import { atom } from "recoil";

export interface PermanentDataType {
  isHighlghtIndicatorClicked?: boolean;
  isWebview?: boolean;
  homeIndicatorHeight?: number;
  appVersion?: string;
  audioCurrentTime?: { audioInstanceKey: string; currentTime: number };
  isAppLockEnabled?: boolean;
}

export const permanentDataAtom = atom<PermanentDataType | undefined>({
  key: "permanentData",
  default: { homeIndicatorHeight: 20 },
  effects: [
    ({ setSelf, onSet }) => {
      const savedData = localStorage.getItem("permanentData");
      // setSelf: atom 값을 설정 혹은 재설정
      if (savedData) {
        const parsed = JSON.parse(savedData);
        // 구버전 포맷(숫자) → 오디오 식별 키가 없어 다른 플레이어로 재생바가 새던 문제로 폐기
        if (parsed && typeof parsed.audioCurrentTime === "number") {
          parsed.audioCurrentTime = undefined;
        }
        setSelf(parsed);
      }

      // atom이 변화가 감지될 때 작동, Storage에 데이터 저장
      // setSelf에 의해서는 작동하지 않음
      onSet((newValue, _, isReset) => {
        isReset
          ? localStorage.removeItem("permanentData")
          : localStorage.setItem("permanentData", JSON.stringify(newValue));
      });
    },
  ],
});
